import { useEffect, useState } from "react";

import { getMyLikedPostIds } from "../lib/postLikes";

export function useMyPostLikes(postIds: string[], uid?: string | null) {
  const [likedPostIds, setLikedPostIds] = useState<Set<string>>(() => new Set());
  const postIdsKey = postIds.join("|");

  useEffect(() => {
    let alive = true;
    setLikedPostIds(new Set());
    const ids = postIdsKey ? postIdsKey.split("|") : [];

    if (!uid || !ids.length) return () => { alive = false; };

    getMyLikedPostIds(ids, uid)
      .then((next) => {
        if (alive) setLikedPostIds(next);
      })
      .catch(() => {
        if (alive) setLikedPostIds(new Set());
      });

    return () => {
      alive = false;
    };
  }, [postIdsKey, uid]);

  return { likedPostIds, setLikedPostIds };
}
